module.exports = __webpack_public_path__ + "img/banner2_opt.a238959d.jpg";